import { motion } from "framer-motion";
import { Users, CalendarClock } from "lucide-react";
import ReferralLinkCopy from "./ReferralLinkCopy";
import { useProfile } from "@/lib/api";
import { useShowReferralSection } from "@/lib/features";
import { useT } from "@/lib/i18n";

interface CityUnlockSectionProps {
  cityLaunched?: boolean;
}

export default function CityUnlockSection({ cityLaunched = false }: CityUnlockSectionProps) {
  const { t } = useT();
  const { data: profileData } = useProfile();
  const showReferralSection = useShowReferralSection();
  const referralId = profileData?.data?.user?.referralId;

  const titleKey = cityLaunched ? 'cityUnlock.moreEventsTitle' : 'cityUnlock.title';
  const description1Key = cityLaunched ? 'cityUnlock.moreEventsDescription1' : 'cityUnlock.description1';
  const Icon = cityLaunched ? CalendarClock : Users;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="card py-5"
    >
      <div className="max-w-xl mx-auto text-center">
        <Icon className="w-8 h-8 text-primary-500 mx-auto mb-3" />

        <h3 className="text-base font-semibold mb-2 dark:text-neutral-100">
          {t(titleKey)}
        </h3>

        <div className="space-y-2 text-sm text-dark-muted dark:text-neutral-400 mb-4">
          <p>{t(description1Key)}</p>
          {!cityLaunched && <p>{t('cityUnlock.description2')}</p>}
        </div>

        {showReferralSection && referralId && (
          <div className="pt-3 border-t border-divider dark:border-neutral-700">
            <p className="text-xs font-medium text-dark-muted dark:text-neutral-400 mb-2">
              {t('cityUnlock.shareReferral')}
            </p>
            <ReferralLinkCopy referralId={referralId} variant="compact" />
          </div>
        )}
      </div>
    </motion.div>
  );
}

